import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Accordion } from 'react-bootstrap';

import FormattedMessage from '../../../components/FormattedMessage';
import { CustomMultiselect, defaultRenderer, MemberItemRenderer } from '../../../components/Filter/components/common';
import translateUtility from '../../../util/translate';
// Import Style
import '../../../components/Filter/Filter.scss';

const FILTER = ['queue-states', 'file-type', 'members'];

class DashboardAccordion extends Component {
  static defaultProps = {
    dashboard: {},
    isExpanded: false,
    onChange: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      queueLists: [],
      labels: [],
      cfs: [],
      selectedQueueLists: [],
      selectedLabels: [],
      selectedMembers: [],
      expandedFilters: []
    };
  }

  componentDidMount() {
    if (!!this.props.dashboard) {
      if (this.props.dashboard.allMembers && this.props.dashboard.allMembers.length > 0)
        {
           this.props.dashboard.allMembers[0].label = translateUtility.translate(`${this.props.app}.no-member`)
        };
      this.setFilters();
      this.initFilterExpanded();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.dashboard, this.props.dashboard)) {
      this.setFilters();
      this.initFilterExpanded();
    }
  }

  setFilters = () => {
    const newState = {
      queueLists: this.props.dashboard.lists,
      labels: this.props.dashboard.allLabels,
      cfs: this.props.dashboard.allCustomFields,
      selectedQueueLists: this.props.dashboard.queueLists,
      members: this.props.dashboard.allMembers
    };

    newState.selectedLabels =
      this.props.dashboard.labels && this.props.dashboard.labels.length
        ? this.props.dashboard.labels
        : _.map(this.props.dashboard.allLabels, l => l.value);

    newState.selectedMembers =
      this.props.dashboard.members && this.props.dashboard.members.length
        ? this.props.dashboard.members
        : _.map(this.props.dashboard.allMembers, l => l._id);

    _.forEach(this.props.dashboard.allCustomFields, cf => {
      const fieldConfig = _.find(this.props.dashboard.customFields, { fieldId: cf.id });
      if (fieldConfig && fieldConfig.values && fieldConfig.values.length) {
        newState[`selected${cf.id}`] = fieldConfig.values;
      } else {
        newState[`selected${cf.id}`] = _.map(cf.options, f => f.value);
      }
    });

    this.setState(newState, this.onChange);
  };

  initFilterExpanded() {
    const cfEventKeys = _.map(this.props.dashboard.allCustomFields, (cf, i) => i);
    this.setState({
      expandedFilters: FILTER.concat(cfEventKeys),
      initial: false
    });
  }

  handleChange = (selected, name, isCf) => {
    this.setState(
      {
        [`selected${isCf ? name : _.upperFirst(name)}`]: selected
      },
      this.onChange
    );
  };

  onChange = () => {
    const data = {
      dashboardId: this.props.dashboard._id,
      queueLists: this.state.selectedQueueLists || [],
      labels: [],
      members: [],
      customFields: []
    };

    if (
      this.state.selectedLabels.length > 0 &&
      this.state.selectedLabels.length < this.props.dashboard.allLabels.length
    ) {
      data.labels = this.state.selectedLabels;
    }

    if (
      this.state.selectedMembers.length > 0 &&
      this.state.selectedMembers.length < this.props.dashboard.allMembers.length
    ) {
      data.members = this.state.selectedMembers;
    }

    _.forEach(this.props.dashboard.allCustomFields, cf => {
      const values = this.state[`selected${cf.id}`];
      if (values && values.length > 0 && values.length < cf.options.length) {
        data.customFields.push({
          fieldId: cf.id,
          values
        });
      }
    });

    this.props.onChange(data);
  };

  handleFilterSelect = e => {
    this.setState({
      expandedFilters: e
    });
  };

  render() {
    const { queueLists, labels, cfs, selectedQueueLists, selectedLabels, members, selectedMembers } = this.state;

    return (
      <Accordion
        defaultActiveKey="file-type"
        alwaysOpen
        activeKey={this.state.expandedFilters}
        onSelect={e => this.handleFilterSelect(e)}
      >
        <Accordion.Item eventKey="queue-states">
          <Accordion.Header>
            <React.Fragment>Queue states</React.Fragment>
          </Accordion.Header>
          <Accordion.Body>
            <CustomMultiselect
              name={'queueLists'}
              items={queueLists}
              selectedItems={selectedQueueLists}
              onSelect={this.handleChange}
              itemRenderer={defaultRenderer}
            />
          </Accordion.Body>
        </Accordion.Item>
        {this.renderLabels(labels, selectedLabels)}
        {this.renderMembers(members, selectedMembers)}
        {_.map(cfs, (cf, i) => {
          return (
            <Accordion.Item eventKey={i} key={i} uuid={`cf_${i}`}>
              <Accordion.Header>
                <React.Fragment>{cf.name}</React.Fragment>
              </Accordion.Header>
              <Accordion.Body>
                <CustomMultiselect
                  name={cf.name}
                  items={cf.options}
                  selectedItems={this.state[`selected${cf.id}`] || []}
                  onSelect={(selected, name) => this.handleChange(selected, cf.id, true)}
                  itemRenderer={defaultRenderer}
                  fieldId={cf.id}
                />
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    );
  }

  renderLabels(labels, selectedLabels) {
    const { app, dashboard } = this.props;
    const fileApp = app === 'file' && !dashboard.isCsv && (dashboard.isAzure ? 'azure' : 'jira');

    if (labels && labels.length) {
      return (
        <Accordion.Item eventKey="file-type">
          <Accordion.Header>
            <React.Fragment>
              <FormattedMessage id={`${fileApp || app}.label`} mode="capitalize" plural="true" />
            </React.Fragment>
          </Accordion.Header>
          <Accordion.Body>
            <CustomMultiselect
              name={'labels'}
              items={labels}
              selectedItems={selectedLabels}
              onSelect={this.handleChange}
              itemRenderer={defaultRenderer}
            />
          </Accordion.Body>
        </Accordion.Item>
      );
    }
  }

  renderMembers(members, selectedMembers) {
    const { app, dashboard } = this.props;
    const fileApp = app === 'file' && !dashboard.isCsv && (dashboard.isAzure ? 'azure' : 'jira');

    if (members && members.length) {
      return (
        <Accordion.Item eventKey="members" uuid="members">
          <Accordion.Header>
            <React.Fragment>
              <FormattedMessage id={`${fileApp || app}.member`} mode="capitalize" plural="true" />
            </React.Fragment>
          </Accordion.Header>
          <Accordion.Body>
            <div className="member_list">
              <CustomMultiselect
                name={'Members'}
                items={members}
                selectedItems={selectedMembers}
                onSelect={this.handleChange}
                itemRenderer={MemberItemRenderer}
              />
            </div>
          </Accordion.Body>
        </Accordion.Item>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app
  };
};

export default connect(mapStateToProps)(DashboardAccordion);
